import styled from "styled-components"


const StyledGrayCard = styled.div`
    background-color: #F2F2F2;
    border-radius: 10px;
    display: flex;
    color: black;
    padding: 10px;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    /* height: 200px; */
`;
const StyledWrapper = styled.div`
   padding: 10px;
`;
export function ChooseLevelCard({ children, onClick, className, style }) {
    return (
        <StyledWrapper className="grid-card">

            <StyledGrayCard className={className} style={style}>
                {children}
            </StyledGrayCard>

        </StyledWrapper>
    );
}